import { SelectionList } from '@dixa/lib-shared-habla';

import { WebformEndpoint } from 'apis/webformEndpoints';
import { HookFormSelectionListSingle } from 'components/hookForm';

import { messengerSettingsFormFields } from '../../types';

export function EndpointSelector({
  endpoints,
  disabled,
}: {
  endpoints: ReadonlyArray<WebformEndpoint>;
  disabled: boolean;
}): JSX.Element {
  return (
    <HookFormSelectionListSingle
      disabled={disabled}
      label="Webform endpoint"
      rules={{ required: 'Please select a webform endpoint' }}
      name={messengerSettingsFormFields.formOnlyModeEndpointURI}
      componentProps={{
        getItemTitleByValue(endpointURI: string | null | undefined) {
          if (!endpointURI) return '';

          const endpoint = endpoints.find(
            (endpoint) => endpoint.endpoint_uri === endpointURI,
          );

          return endpoint ? extractEndpointLabel(endpoint) : '';
        },
      }}
    >
      {endpoints.map((endpoint) => (
        <SelectionList.Item key={endpoint.id} value={endpoint.endpoint_uri}>
          {extractEndpointLabel(endpoint)}
        </SelectionList.Item>
      ))}
    </HookFormSelectionListSingle>
  );
}

const extractEndpointLabel = (endpoint: WebformEndpoint): string =>
  endpoint.description || endpoint.endpoint_uri || '';
